<div id="forbidden">
  <div class="forbidden">
    <div class="forbidden-403"></div>
    <h1>403</h1>
    <h2>{{ 'error.forbidden.title' | translate }}</h2>
    <p>{{ 'error.forbidden.message' | translate }}</p>
    <a href="/">{{ 'error.forbidden.backToHome' | translate }}</a>
  </div>
</div>